import { TCanvasLink } from "../types/TCanvasLink";

export default function getConnectionCountById(links: TCanvasLink[]): Record<string, number> {
  const connections: Record<string, number> = {};

  links.forEach(link => {
    const sourceId = typeof link.source === 'object' ? link.source.node_id : link.source;
    const targetId = typeof link.target === 'object' ? link.target.node_id : link.target;

    connections[sourceId] = (connections[sourceId] || 0) + 1;
    connections[targetId] = (connections[targetId] || 0) + 1;
  });

  return connections;
}
